import { Button, Dialog, Text } from "@hcsc-fiber/react";
import React, { useContext } from "react";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";

interface RemoveDeviceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  dialogDeviceMessage?: string;
  type: string;
}

export const RemoveDeviceDialog: React.FC<RemoveDeviceDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
  dialogDeviceMessage,
  type,
}) => {
  const language = useContext(StateContext).languageCode;

  return (
    <Dialog onClose={onClose} isOpen={isOpen}>
      <Dialog.Title>
        {type === "passkey"
          ? translations.removePasskeyDialogTitle[language]
          : translations.removeDeviceDialogTitle[language]}
      </Dialog.Title>
      <Dialog.Content>
        <Text as="p" fontWeight={"bold"} margin={[3, 0, 3]}>
          {dialogDeviceMessage}
        </Text>
        <Text as="p" margin={[3, 0, 3]}>
          {type === "passkey"
            ? translations.removePasskeyDialogText[language]
            : translations.removeDeviceDialogText[language]}
        </Text>
      </Dialog.Content>
      <Dialog.Actions>
        <Button kind="primary" onClick={onSubmit} data-testid="removeDialogButton">
          {type === "passkey" ? translations.removePasskey[language] : translations.removeDevice[language]}
        </Button>
        <Button kind="tertiary" onClick={onClose} data-testid={"closeRemoveDialog"}>
          {translations.cancel[language]}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
